Wee.fn.make('solutions', {
	init: function() {
		this.$private.scrollMore();
	},

	unload: function() {
		Wee.events.off(false, 'click.icon');
		Wee.events.off(false, 'click.more');
	}
}, {
	/**
	* Scroll page to target
	*
	* @private
	*/
	scrollMore: function() {
		$.events.on({
			'ref:moreBtn': {
				'click.more': function() {
					$(Wee._body).tween({
						scrollTop: $('ref:moreTarget').offset().top
					});
				}
			},
			'ref:iconAnchor': {
				'click.icon': function(e, el) {
					$(Wee._body).tween({
						scrollTop: $($(el).attr('href')).offset().top - 70
					});

					e.preventDefault();
				}
			}
		});
	}
});